import { render } from "./UsersByCompanyPage.vue?vue&type=template&id=d94040a4&ts=true"
import script from "./UsersByCompanyPage.vue?vue&type=script&lang=ts"
export * from "./UsersByCompanyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__